import {SvgIcon, SvgIconProps} from "@mui/material";
import React from "react";

export const SupportIcon: React.FC<SvgIconProps> = (props) => (
    <SvgIcon sx={{fill: "none", strokeWidth: "1.5", ...props.sx}} viewBox="0 0 18 18">
        <path
            d="M3.344 3.344L6.736 6.736M11.264 11.264L14.656 14.656M14.656 3.344L11.264 6.736L14.088 3.912M3.344 14.656L6.736 11.264M17 9C17 13.4183 13.4183 17 9 17C4.58172 17 1 13.4183 1 9C1 4.58172 4.58172 1 9 1C13.4183 1 17 4.58172 17 9ZM12.2 9C12.2 10.7673 10.7673 12.2 9 12.2C7.23269 12.2 5.8 10.7673 5.8 9C5.8 7.23269 7.23269 5.8 9 5.8C10.7673 5.8 12.2 7.23269 12.2 9Z"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </SvgIcon>
);
